import { Component } from '@angular/core';
import { MenuService } from '../../../core/services/menu.service';
import { CalculationResponse } from '../../../../../../../../common/dist/angular/responses/calculation.response';
import { AlertContextEnum } from '../../../core/enums/alert-context.enum';

@Component({
  selector: 'app-list-calculations',
  templateUrl: './list-calculations.component.html',
  styleUrls: ['./list-calculations.component.scss'],
  standalone: false,
})
export class ListCalculationsComponent {
  alertContextEnum = AlertContextEnum;

  calculations: CalculationResponse[];

  isLoading = true;
  showHasBeenRefreshed = true;

  constructor(public menuService: MenuService) {
  }

}
